import { camelCaseToTitle } from 'utils/helperMethods';

import React from 'react';
import PropTypes from 'prop-types';

const getTextData = (value, isNestedRenderingAllowed) => {
    if (['string', 'number'].includes(typeof value)) {
        // return value;
        return typeof value == "string" ? value.replace(/_/g, " ") : value;
    } else if (typeof value === 'boolean') {
        return value ? 'True' : 'False';
    } else if (
        Array.isArray(value) &&
        value.every(item => ['string', 'number'].includes(typeof item))
    ) {
        return value.length > 0
            ? value.map(item => <p className="user-text">{item}</p>)
            : '-';
    } else if (value === null || value === undefined) {
        return '-';
    } else if (isNestedRenderingAllowed) {
        return <GetValuesRender data={value} />;
    }

    return JSON.stringify(value);
};

const GetValuesRender = ({
    data = {},
    section = '',
    isNestedRenderingAllowed = false,
}) => {
    delete  data.odsConfigInfo;
    return (
        <>
            {data &&
                Object.keys(data).map((key, index) => {
                    return (
                        <div className={`form-field`} key={index}>
                            <p className="label">{camelCaseToTitle(key)}</p>
                            <p className="user-text">
                                {
                                        getTextData(
                                            data[key],
                                            isNestedRenderingAllowed
                                        )
                                }
                            </p>
                        </div>
                    );
                })}
        </>
    );
};

const renderAccountAndEDI = (data, type) => {
    if (type === 'ediConfInfoList') {
        return data?.map((item, index) => (
            <div className="table-container" key={`edi-${index}`}>
                <table className="checker-table" border="1" cellPadding="5" cellSpacing="0" style={{width: '100%'}}>
                    <thead>
                        <tr>
                            <th>EDI Configuration {index + 1}</th>
                            <th style={{fontWeight: 'bold'}}>Is EDI Enabled</th>
                            <th style={{fontWeight: 'bold'}}>Account Number</th>
                            <th style={{fontWeight: 'bold'}}>Debit Amount</th>
                            <th style={{fontWeight: 'bold'}}>Debit Frequency</th>
                            {item.monthlyDebitDate && <th style={{fontWeight: 'bold'}}>Monthly Debit Date</th>}
                            <th style={{fontWeight: 'bold'}}>Debit Type</th>
                            <th style={{fontWeight: 'bold'}}>Settlement Amount Type</th>
                            <th style={{fontWeight: 'bold'}}>Settlement Frequency</th>
                            <th style={{fontWeight: 'bold'}}>Settlement Type</th>
                            <th style={{fontWeight: 'bold'}}>Consent</th>
                            {item.flatAmount && <th style={{fontWeight: 'bold'}}>Flat Amount</th>}
                            {item.totalAmount && <th style={{fontWeight: 'bold'}}>Total Amount</th>}
                            <th style={{fontWeight: 'bold'}}>Start Date</th>
                            <th style={{fontWeight: 'bold'}}>End Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Data</td>
                            <td>{item.ediEnable ? 'Enabled' : 'Disabled'}</td>
                            <td>{item.accountNumber}</td>
                            <td>{item.debitAmountPer}</td>
                            <td>{item.debitFrequency}</td>
                            {item.monthlyDebitDate && <td>{item.monthlyDebitDate}</td>}
                            <td>{item.debitType}</td>
                            <td>{item.settlementAmountType}</td>
                            <td>{item.settlementFrequency}</td>
                            <td>{item.settlementType}</td>
                            <td>{item.consent ? 'Accepted' : 'Denied'}</td>
                            {item.flatAmount && <td>{item.flatAmount}</td>}
                            {item.totalAmount && <td>{item.totalAmount}</td>}
                            <td>{item.startDate}</td>
                            <td>{item.endDate}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ));
    }

    return data.map((item, index) => (
        <div className="table-container" key={`account-${index}`}>
            <table className="checker-table" border="1" cellPadding="5" cellSpacing="0" style={{width: '100%'}}>
                <thead>
                    <tr>
                        <th>Account Details {index + 1}</th>
                        <th style={{fontWeight: 'bold'}}>Account Holder Name</th>
                        <th style={{fontWeight: 'bold'}}>Account Number</th>
                        <th style={{fontWeight: 'bold'}}>Account Ownership</th>
                        <th style={{fontWeight: 'bold'}}>Debit Frequency</th>
                        {item.accountType && <th style={{fontWeight: 'bold'}}>Account Type</th>}
                        <th style={{fontWeight: 'bold'}}>Bank Name</th>
                        <th style={{fontWeight: 'bold'}}>IFSC Code</th>
                        <th style={{fontWeight: 'bold'}}>Is Primary</th>
                        <th style={{fontWeight: 'bold'}}>Status</th>
                        <th style={{fontWeight: 'bold'}}>Is verified</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Data</td>
                        <td>{item.accountHolderName}</td>
                        <td>{item.accountNumber}</td>
                        <td>{item.accountOwnership}</td>
                        <td>{item.debitFrequency}</td>
                        {item.accountType && <td>{item.accountType}</td>}
                        <td>{item.bankName}</td>
                        <td>{item.ifscCode}</td>
                        <td>{item.primary ? "Yes" : "No"}</td>
                        <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                        <td>{item.verified ? "Yes" : "No"}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    ));
};

GetValuesRender.propTypes = {
    data: PropTypes.object,
    section: PropTypes.string,
    isNestedRenderingAllowed: PropTypes.bool,
};

export { GetValuesRender, getTextData };
